/* eslint-disable no-mixed-spaces-and-tabs */
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Load Icons
import { defineElement } from 'lord-icon-element';
import lottie from 'lottie-web';

import { SimplebarAngularModule } from 'simplebar-angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { PlotlyModule } from 'angular-plotly.js';
import * as PlotlyJS from 'plotly.js-dist-min';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { FlatpickrModule } from 'angularx-flatpickr';

import { ClientsComponent } from './clients.component';
import { ClientsSidebarComponent } from './clients-sidebar/clients-sidebar.component';
import { ClientContentComponent } from './client-content/client-content.component';
import { ClientsRoutingModule } from './clients-routing.module';
import { ClientPlansComponent } from './client-content/client-plans/client-plans.component';
import { ClientActivitiesComponent } from './client-content/client-activities/client-activities.component';
import { ClientUsersComponent } from './client-content/client-users/client-users.component';

PlotlyModule.plotlyjs = PlotlyJS;

@NgModule({
  declarations: [
		ClientsComponent,
  	ClientsSidebarComponent,
   	ClientContentComponent,
    ClientPlansComponent,
    ClientActivitiesComponent,
    ClientUsersComponent
	],
  imports: [
    CommonModule,
    ClientsRoutingModule,
		SimplebarAngularModule,
		FlatpickrModule.forRoot(),
		NgCircleProgressModule.forRoot(),
		NgxChartsModule,
		PlotlyModule,
		SharedModule,
		NgbModule,
		NgbNavModule
  ],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ClientsModule {
	constructor() {
    defineElement(lottie.loadAnimation);
  }
}
